import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/layout/Main'
import _404 from '@/assets/page/404'

import Login from '@/view/base/login'
import Register from '@/view/base/register'
import home from '@/view/base/home'

import system from './system'
import front from './front'
import base from '@/view/base'



Vue.use(Router)

const routers = new Router({
	mode: 'history',
	routes: [{
		path: '/404',
		name: '_404',
		component: _404,
	}, {
		path: '/:code',
		name: 'base',
		component: base,
		children: [{
			path: 'login',
			name: 'login',
			component: Login,
		}, {
			path: '',
			name: 'Main',
			component: Main,
			children: [{ //系统管理
					path: 'home',
					name: 'home',
					component: home,
				},
				...system,
				...front
			]
		}],
	}]
});


// 路由前置守卫
routers.beforeEach(function(to, from, next) {
	console.log(to)
	if (to.name == null) {
		routers.push('/404');
		return;
	}
	next();
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/index.js